import React, { useEffect, useState } from 'react';
import { PrimaryButton } from './PrimaryButton';
import { CHECKOUT_URL } from '../../utils/checkout';
import { trackMetaEvent } from '../../utils/metaPixel';
export function StickyCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let ticking = false;
    const handleScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        setVisible(window.scrollY > 640);
        ticking = false;
      });
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-40 border-t border-navy/10 bg-white/95 backdrop-blur-sm transition-transform duration-300 lg:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-207" data-mp="2ixlsynao3321">
      <div className="flex items-center justify-between gap-3 px-4 py-3" data-id="element-208" data-mp="2sxcrd02cm27e">
        <div data-id="element-209" data-mp="o1mnnhmtmfes">
          <p className="font-heading text-sm font-bold text-navy" data-id="element-210" data-mp="o1wcv301kijf">19€</p>
          <p className="text-[11px] text-muted" data-id="element-211" data-mp="s1en94u8lb80">Acceso inmediato</p>
        </div>
        <PrimaryButton size="md" showArrow={false} href={CHECKOUT_URL} onClick={() => trackMetaEvent('InitiateCheckout', {
        value: 19,
        currency: 'EUR'
      })} data-id="element-212" data-mp="x1j6h2mj4k1x">
          Acceso Ahora
        </PrimaryButton>
      </div>
    </div>;
}